import { z } from "zod";
import {
  BaseContactSchema,
  ContactAddressSchema,
  ContactEmailSchema,
  ContactFaxSchema,
  ContactPhoneSchema,
  ContactPortalAccessSchema,
} from "../contact/ContactSchema";

export const ConnectionContactSchema = z.object({
  ...BaseContactSchema.partial().shape,
  dateCreated: z.string().nullish(),
  dateModified: z.string().nullish(),
  portalAccess: ContactPortalAccessSchema.nullish(),
  addresses: z.array(ContactAddressSchema).optional(),
  emails: z.array(ContactEmailSchema).optional(),
  phones: z.array(ContactPhoneSchema).optional(),
  faxes: z.array(ContactFaxSchema).optional(),
  groupName: z.string().nullable(),
  id: z.string(),
  individualFirstName: z.string().nullable(),
  individualLastName: z.string().nullable(),
  individualMiddleName: z.string().nullable(),
  individualMinor: z.boolean().nullable().optional(),
  individualDeceased: z.boolean().nullable().optional(),
  organizationName: z.string().nullable(),
  primaryEmail: z
    .object({
      address: z.string(),
      id: z.string(),
      label: z.string().nullable(),
    })
    .nullable()
    .optional(),
  primaryPhone: z
    .object({
      extension: z.string().nullable(),
      id: z.string(),
      label: z.string().nullable(),
      number: z.string(),
    })
    .nullable()
    .optional(),
  type: z.enum(["individual", "organization", "group"]),
});

export const ConnectionSchema = z.object({
  editRevision: z.number().int().min(1),
  lifecycleRootId: z.string(),
  connectionType: z.string(),
  contact: ConnectionContactSchema.nullable(),
  dateCreated: z.string(),
  dateModified: z.string(),
  description: z.string().nullable(),
  dateTimeEnd: z.string().nullable(),
  dateTimeStart: z.string().nullable(),
  faultStatus: z.string().nullable(),
  id: z.string(),
  insuranceCoverage: z.string().nullable(),
  pending: z.boolean().nullable(),
  revokedAt: z.string().nullable(),
  signatureRequestComplete: z.boolean().nullable(),
  signatureRequestRequired: z.boolean().nullable(),
  signatureTemplateSlot: z.string().nullable(),
  signerOrder: z.number().int().nullable(),
  sourceObjectId: z.string(),
  sourceObjectType: z.string(),
  state: z.enum(["active", "scheduled", "ended", "removed"]),
  supersedesObjectConnectionId: z.string().nullable(),
  targetObjectId: z.string(),
  targetObjectType: z.string(),
  witnessStatus: z.string().nullable(),
});

export const ConnectionCreateSchema = ConnectionSchema.pick({
  connectionType: true,
  sourceObjectId: true,
  sourceObjectType: true,
  targetObjectId: true,
  targetObjectType: true,
})
  .extend(
    ConnectionSchema.pick({
      dateTimeEnd: true,
      dateTimeStart: true,
      description: true,
      faultStatus: true,
      insuranceCoverage: true,
      witnessStatus: true,
    }).partial().shape,
  )
  .extend({
    operationId: z.string().uuid().optional(),
  });
